export default __webpack_public_path__ + "static/media/ETH2x.e525cb34.png";